<template>
  <v-card v-if="ie">
    <v-form ref="form" v-model="valid" :lazy-validation="true">
      <v-card v-if="mode === 'create'">
        <v-card-title>Utfärda ny dispens</v-card-title>
        <v-card-actions>
          <v-icon
            class="close"
            @click="
              $emit('close'), (editExemptionReason = false), (editProfession = false), (editRegion = false)
            "
            >$sl-close</v-icon
          >
        </v-card-actions>
        <v-card-text>
          <template>
            <v-select
              outlined
              v-model="createData.professionId"
              :items="
                basicProfessions.map((o) => {
                  return { id: o.id, text: o.name };
                })
              "
              item-text="text"
              item-value="id"
              label="Yrke"
              :rules="[rules.required]"
              append-icon="$sl-arrow-down"
            ></v-select>
            <v-select
                v-if="isMachinesProfession"
                outlined
                multiple
                v-model="createData.machineIds"
                :items="professionMachines"
                item-text="text"
                item-value="id"
                label="Maskinslag"
                data-cy="selectMachineProfession"
                :rules="[rules.notEmpty]"
            ></v-select>
            <v-select
              outlined
              v-model="createData.regionId"
              :items="selectableRegions"
              item-text="text"
              item-value="id"
              label="Region"
              :rules="[rules.required]"
              append-icon="$sl-arrow-down"
            ></v-select>

            <v-textarea
              :rules="[rules.required]"
              label="Motivering"
              outlined
              v-model="createData.exemptionReason"
            ></v-textarea>
            <v-row>
              <v-col cols="12" md="6" class="mt-n3">
                <DatePicker
                  placeholder="ÅÅÅÅ-MM-DD"
                  :icon="'$sl-calendar-date'"
                  label="Utfärdandedatum"
                  outlined
                  v-model="createData.issuedOn"
                  ref="datePicker"
                />
              </v-col>
            </v-row>
          </template>
        </v-card-text>
      </v-card>

      <!-- Edit dispens  starts here-->
      <v-card v-else-if="mode === 'edit' || mode === 'approve'">
        <v-card-title> DISPENSANSÖKAN </v-card-title>
        <v-card-actions>
          <v-icon
            class="close"
            @click="
              $emit('close'), (editExemptionReason = false), (editProfession = false), (editRegion = false)
            "
            >$sl-close</v-icon
          >
        </v-card-actions>
        <v-card-text>
          <template v-if="ie">
            <v-row no-gutters>
              <v-col cols="4">
                <p class="overline">Ansökan skapad av</p>
                <p class="mt-n3" v-if="ie.appliedBy">
                  <a :href="'mailto:' + ie.appliedBy.email">
                    {{ ie.appliedBy | fullName }}</a
                  >
                </p>
                <p class="mt-n3" v-else-if="ie.issuedBy">
                  <a :href="'mailto:' + ie.issuedBy.email">
                    {{ ie.issuedBy | fullName }}</a
                  >
                </p>
              </v-col>
              <v-col cols="3">
                <p class="overline">Ansökningsdatum</p>
                <p class="mt-n3" v-if="get(ie, 'createdAt', null)">
                  {{ get(ie, 'createdAt', '') | date }}
                </p>
              </v-col>
              <v-col cols="5" class=""
                ><p class="overline">E-POSTADRESS</p>
                <p class="mt-n3" v-if="ie.appliedBy && ie.appliedBy.email">
                  <a :href="'mailto:' + ie.appliedBy.email"> {{ ie.appliedBy.email }}</a>
                </p>
                <p class="mt-n3" v-else-if="ie.issuedBy && ie.issuedBy.email">
                  <a :href="'mailto:' + ie.issuedBy.email"> {{ ie.issuedBy.email }}</a>
                </p>
              </v-col>
              <v-col cols="4">
                <p class="overline">Ansökan gäller</p>
                <p class="mt-n3" v-if="selectedPerson">
                  <router-link :to="'/people/' + selectedPerson.id">{{
                    selectedPerson | fullName
                  }}</router-link>
                </p>
              </v-col>
              <v-col cols="3">
                <p class="overline">MOBILNUMMER</p>
                <p class="mt-n3" v-if="selectedPerson && selectedPerson.mobilephone">
                  <a :href="`tel:${selectedPerson.mobilephone}`">
                    {{ selectedPerson.mobilephone }}</a
                  >
                </p>
              </v-col>
              <v-col cols="5">
                <p class="overline">E-POSTADRESS</p>
                <p class="mt-n3" v-if="selectedPerson && selectedPerson.email">
                  <a :href="`mailto:${selectedPerson.email}`">
                    {{ selectedPerson.email }}</a
                  >
                </p>
              </v-col>
            </v-row>

            <p class="overline mt-3">BYN-REGION</p>
            <div class="d-flex" v-if="!editRegion">
              <p class="mt-n3">
                {{ ieRegion }}
              </p>
              <v-btn
                class="ml-n6 mt-n7"
                @click="editRegion = true"
                text
                :disabled="isDisabled || !canApprove ||!canUpdate"
              >
                <v-icon small>$sl-edit</v-icon>
              </v-btn>

            </div>
            <div v-else class="mb-8">
              <v-select
                data-cy="select-region"
                :items="allRegions"
                outlined
                v-model="createData.regionId"
                id="regionSelect"
                :rules="[rules.required]"
                append-icon="$sl-arrow-down"
              ></v-select>
              <p class="mt-n4">
                När du ändrar BYN-region flyttas ansökan omgående till den valda regionen. Det kan innebära att ansökan inte längre syns för dig på sidor i Registret som listar dispensansökningar.
              </p>
              <v-btn outlined @click="changeRegion"><v-icon>$sl-double-arrow-right</v-icon>FLYTTA TILL VALD BYN-REGION</v-btn>
            </div>
            <p class="overline mt-0">TYP AV DISPENS</p>
            <p class="mt-n3">Handledare</p>

            <p class="overline mt-3">HANDLEDARYRKE</p>
            <div class="d-flex" v-if="!editProfession ">
              <p class="mt-n3">
                {{ getProfessionNameById(ie.professionId) }}
              </p>
            </div>
            <div v-else>
              <v-select
                outlined
                v-model="createData.professionId"
                :items="
                  basicProfessions.map((o) => {
                    return { id: o.id, text: o.name };
                  })
                "
                item-text="text"
                item-value="id"
                label="Yrke"
                :rules="[rules.required]"
                append-icon="$sl-arrow-down"
              ></v-select>
            </div>

            <v-select
                v-if="isMachinesProfession"
                outlined
                multiple
                v-model="initialSelectValue"
                :items="professionMachines"
                item-text="text"
                item-value="id"
                label="Maskinslag"
                data-cy="selectMachineProfession"
                :rules="[rules.notEmpty]"
                :disabled="ie.issuedById > 0"
            ></v-select>

            <div v-if="!editExemptionReason">
              <p class="overline mt-4">Motivering</p>
              <div class="d-flex">
                <p class="mt-n3" v-if="ie && ie.exemptionReason">
                  {{ ie.exemptionReason }}
                </p>
                <!-- <v-btn
                  class="ml-n6 mt-n7"
                  @click="editExemptionReason = true"
                  text
                  :disabled="isDisabled"
                >
                  <v-icon small>$sl-edit</v-icon>
                </v-btn> -->
              </div>
            </div>
            <div v-else>
              <v-textarea
                :rules="[rules.required]"
                label="Motivering"
                outlined
                v-model="createData.exemptionReason"
              ></v-textarea>
            </div>

            <div class="overline mt-4">Filbilagor</div>
            <template v-if="ie.documents && ie.documents.length > 0">
              <div v-for="(doc, index) in ie.documents" :key="index">
                <a @click="getDocument(doc)">{{ doc.name }}</a>
                <span class="brown-grey small-text"> ({{ getDocSize(doc.size) }})</span>
              </div>
            </template>
            <p class="mt-0 grey-text font-italic" v-else>Bilagor saknas.</p>
            <v-spacer class="mb-6"></v-spacer>
            <v-row>
              <v-col cols="6"
                ><p class="overline mt-3">Godkänd av (1)</p>
                <p class="mt-n3" v-if="ie && ie.issuedBy">
                  <a :href="'mailto:' + ie.issuedBy.email">{{
                    ie.issuedBy | fullName
                  }}</a>
                  <span v-if="ie.issuedOn"> ({{ ie.issuedOn | date }})</span>
                </p>
                <p class="mt-n3 grey-text font-italic" v-else>Ej godkänd.</p>
              </v-col>
              <v-col cols="6"
                ><p class="overline mt-3">Godkänd av (2)</p>
                <p class="mt-n3" v-if="ie && ie.approvedBy">
                  <a :href="'mailto:' + ie.approvedBy.email">{{
                    ie.approvedBy | fullName
                  }}</a>
                  <span v-if="ie.approvedOn"> ({{ ie.approvedOn | date }})</span>
                </p>
                <p class="mt-n3 grey-text font-italic" v-else>Ej godkänd.</p>
              </v-col>
            </v-row>
          </template>
        </v-card-text>
      </v-card>

      <v-card-actions class="justify-end mt-n6">
        <v-btn
          color="secondary"
          @click="$emit('close'), (editExemptionReason = false), (editProfession = false), (editRegion = false)"
        >
          <v-icon>$sl-cancel</v-icon>Avbryt
        </v-btn>
        <v-btn v-if="mode === 'create'" @click="saveExemption" :disabled="!canCreate">
          <v-icon>$sl-check</v-icon>Utfärda
        </v-btn>
        <v-btn class="testVk" :disabled="editRegion || !canCreate" data-cy="delete-exemption-modal" outlined v-if="mode === 'edit'" @click="$emit('delete', ie)">
          <v-icon>$sl-delete</v-icon>Radera
        </v-btn>
        <v-btn v-if="canApprove && mode == 'edit' && canApproveProfession" :disabled="editRegion || !canUpdate" @click="approveClicked(ie)">
          <v-icon>$sl-like</v-icon>Godkänn
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import DatePicker from "@/components/common/DatePicker";
import API from "@/services/api.js";
import { UserRules, CanIDo } from "@/components/mixins";
import fileDownload from "js-file-download";
import PersonAutocomplete from "@/components/common/AutoComplete/PersonAutocomplete";
import { Regions, RulesMixin } from "@/components/mixins";
import get from 'lodash/get'

// @group Person
// PersonInstructorExemptionsModal component
export default {
  name: "PersonInstructorExemptionsModal",
  mixins: [Regions, RulesMixin, UserRules, CanIDo],
  components: {
    DatePicker,
    PersonAutocomplete,
  },
  data: () => ({
    valid: true,
    modeData: "",
    canApprove: false,
    isDisabled: true,
    editProfession: false,
    editRegion: false,
    editExemptionReason: false,
    createData: {
      personId: null,
      exemptionReason: null,
      regionId: null,
      professionId: null,
      issuedOn: null,
      machineIds: [],
    }, 
  }),

  props: {
    // instructor exemption object
    ie: Object,
    // modal mode string
    mode: String,
  },
  computed: {
    ...mapGetters("person", ["selectedPerson"]),
    ...mapGetters("currentuser", ["currentUser", "currentUserRole"]),
    ...mapGetters("basic", ["basicProfessions", "basicRegions", "getProfessionNameById", "getRegionById"]),

    initialSelectValue() {
      return this.selectedPerson?.machinequalifications.map(o => {
        return {
          id: o.machine.id,
          text: o.machine.name
        }
      })
    },

    professionMachines() {
      let ret = [];
      const selectedProfession = this.basicProfessions.find(
          (p) => p.id === this.createData.professionId
      );

      if (selectedProfession && selectedProfession.machineOrientations) {
        ret = selectedProfession.machineOrientations.map((o) => {
          return { id: o.machine.id, text: o.name };
        });
      }
      return ret;
    },

    isMachinesProfession() {
      if (!this.createData.professionId) return false;
      const selectedProfession = this.basicProfessions.find(
          (p) => p.id === this.createData.professionId
      );
      return selectedProfession && selectedProfession.isMachineProfession;
    },

    allRegions() {
      return this.basicRegions.map(r => {return {text: r.name, value: r.id}})
    },

    ieRegion() {
      const r = this.getRegionById(this.ie.regionId)
      return r ? r.name : '' 
    },

    canApproveProfession() {
      const adminRole = get(this, 'currentUser.userrole.role', null) === 'admin'
      if ( !adminRole && get(this, 'createData.professionId', null) === 2045 ) return false
      return true
    }
  },

  asyncComputed: {
    canUpdate(){
      return this.canIDo('instructor-exemption', 'update');
    },
    canCreate(){
      return this.canIDo('instructor-exemption', 'create');
    },
  },

  created() {
    if (this.ie && this.mode === "edit") {
      this.createData.exemptionReason = this.ie.exemptionReason;
      this.createData.professionId = this.ie.professionId;
    } else {
      this.createData.exemptionReason = "";
      this.createData.professionId = -1;
    }
  },
  watch: {
    ie: {
      handler: function () {
        if (this.ie && this.ie.approvedById && this.ie.approvedById > 0) {
          this.isDisabled = true;
          this.canApprove = false;
        } else if (this.ie && this.mode == "edit") {
          this.createData.exemptionReason = this.ie.exemptionReason;
          this.createData.regionId = this.ie.regionId;
          this.createData.professionId = this.ie.professionId;
          this.isDisabled = false;
          this.canApprove = this.canUserApprove(this.ie.issuedById)
        }
      },
      immediate: true,
      deep: true,
    },
    mode: {
      handler: function () {
        if (this.mode == "create") {
          this.createData.exemptionReason = "";
          this.createData.professionId = -1;
          return;
        }
        if (this.ie.approvedById && this.ie.approvedById > 0) {
          this.isDisabled = true;
        } else if (this.mode == "edit") {
          this.isDisabled = false;
        }
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions("person", ["setSelectedPerson"]),

    get,

    canUserApprove(issuerById) {
      if(this.currentUser.id !== issuerById) {
        return true
      }

      return false
    },

    changeRegion() {
      if (this.createData.regionId != this.ie.regionId) {
        this.ie.regionId = this.createData.regionId
        this.$emit("edit", this.ie);
      }
    },

    approveClicked(ie) {
      if (
        this.createData.exemptionReason != ie.exemptionReason ||
        this.createData.professionId != ie.professionId
      ) {
        ie.issuedBy = null;
        ie.issuedById = null;
        ie.issuedOn = null;
      }

      this.$emit("approve", ie);
    },
    saveExemption() {
      if (
        !this.$refs.form.validate() ||
        (this.createData &&
          (this.createData.exemptionReason == null ||
            !this.$refs.datePicker.$refs.form.validate() ||
            this.createData.professionId == null ||
            this.createData.issuedOn == null ||
            this.createData.regionId == null))
      ) {
        return this.$events.fire("showError", "Formuläret är inte korrekt ifyllt.");
      }

      this.$emit("create", this.createData);
    },
    getDocSize(bytes) {
      if (bytes >= 1073741824) {
        bytes = (bytes / 1073741824).toFixed(0) + " GB";
      } else if (bytes >= 1048576) {
        bytes = (bytes / 1048576).toFixed(0) + " MB";
      } else if (bytes >= 1024) {
        bytes = (bytes / 1024).toFixed(0) + " kB";
      } else if (bytes > 1) {
        bytes = bytes + " bytes";
      } else if (bytes == 1) {
        bytes = bytes + " byte";
      } else {
        bytes = "0 bytes";
      }
      return bytes;
    },
    getDocument(doc) {
      API.getDocuments(doc.id)
        .then((response) => {
          this.isDisabled = true;
          fileDownload(response.data, doc.name, response.headers["content-type"]);
        })
        .catch((error) => {
          console.log("get document error, " + doc, error);
        });
    },
    editData() {
      if (
        !this.$refs.form.validate() ||
        (this.createData &&
          (this.createData.exemptionReason == null ||
            this.createData.professionId == null))
      ) {
        return this.$events.fire("showError", "Formuläret är inte korrekt ifyllt.");
      }

      this.editProfession = false;
      this.editRegion = false;
      this.editExemptionReason = false;
      this.ie.exemptionReason = this.createData.exemptionReason;
      this.ie.professionId = this.createData.professionId;
      this.ie.issuedBy = null;
      this.ie.issuedById = null;
      this.ie.issuedOn = null;
      this.$emit("edit", this.ie);
    },
  },
};
</script>

<style></style>
